// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__mXy5V","notes":"Notes_notes__lLuhz"};